import { APP_WILL_MOUNT } from '../base/app/actionTypes';
import { CONFERENCE_JOINED } from '../base/conference/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { setNkfAecBypass } from '../stream-effects/nkf-aec/createNkfAecEffect';
import { isNkfAecEnabled } from './functions';
/**
 * Keeps the live NKF-AEC effect in sync with the persisted user ON/OFF choice.
 * On startup the effect may not exist yet — setNkfAecBypass remembers the value
 * and createNkfAecEffect applies it when the effect is built. CONFERENCE_JOINED
 * re-applies it once the effect is definitely running.
 *
 * @param {IStore} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case APP_WILL_MOUNT:
        case CONFERENCE_JOINED:
            setNkfAecBypass(!isNkfAecEnabled(store.getState()));
            break;
    }
    return next(action);
});
